import { Observable, of, throwError } from 'rxjs';
import { parse } from 'query-string';
import { Map } from 'immutable';
import { flog } from '@zambezi/caballo-vivo';
import { pluckTokenFromHash } from '@apiEnabler/api-enabler-common/lib/url-params';
import { sanitizeUrl } from '@braintree/sanitize-url';
var hashFragment = window.location.hash;
var query = Map(parse(window.location.search));
var pathName = window.location.pathname;
var token = pluckTokenFromHash();
var error = pluckErrorFromHash();
var errorUrl = pluckResumeUrlFromHash();
export var errorUrl$ = Observable.create(function (observer) {
  try {
    var url = sanitizeUrl(atob(errorUrl || process.env.REACT_APP_RESUME_URL || ''));
    observer.next(url);
    observer.complete();
  } catch (err) {
    observer.error("Cannot retrieve error url: ".concat(err ? err.message : err));
  }
}).pipe(flog('Error Url retrieved'));
export var authToken$ = error ? throwError(error) : token ? of(token) : throwError(Object.assign(new Error('Missing access token'), {
  type: 'missing-access-token'
}));
export var isClearSpendInPath$ = of(isClearSpendSpecificUrl()).pipe(flog('Is ClearSpend retrieved from path'));
export var isCouttsClearSpendInPath$ = of(isCouttsClearSpendSpecificUrl()).pipe(flog('Is Coutts ClearSpend retrieved from path'));
export var isOneAccountInPath$ = of(isOneAccountSpecificUrl()).pipe(flog('Is OneAccount retrieved from path'));
export var isNatWestOneAccountInPath$ = of(isNatWestOneAccountSpecificUrl()).pipe(flog('Is NatWestOneAccount retrieved from path'));
export var queryCustomerType$ = query.has('cust_type') ? of(query.get('cust_type')).pipe(flog('Customer type retrieved from query')) : of(undefined).pipe(flog('Customer type not provided in query'));
export var mmlPersonalAppSupported$ = query.has('MMLPersonalEnabled') ? of(query.get('MMLPersonalEnabled') === 'true').pipe(flog('MML personal app supported flag retrieved from query')) : of(false).pipe(flog('MML personal app supported flag NOT provided in query'));
export var mmlBusinessAppSupported$ = query.has('MMLBusinessEnabled') ? of(query.get('MMLBusinessEnabled') === 'true').pipe(flog('MML business app supported flag retrieved from query')) : of(false).pipe(flog('MML business app supported flag NOT provided in query'));
function pluckErrorFromHash() {
  var authError = /error=([^&]+)&?/;
  var hasError = hashFragment.match(authError);
  if (hasError) {
    return Object.assign(new Error("OAuth Error: ".concat(hasError[1].toString())), {
      type: 'oauth-error'
    });
  }
}
function pluckResumeUrlFromHash() {
  var matched = hashFragment.match(/resume_url=([^&]+)&?.*/);
  return matched && matched.length === 2 ? matched[1] : null;
}
function isClearSpendSpecificUrl() {
  return pathName.indexOf('/clearspend') !== -1;
}
export function isCouttsClearSpendSpecificUrl() {
  return pathName.indexOf('/coutts-clearspend') !== -1;
}
function isOneAccountSpecificUrl() {
  return pathName.indexOf("".concat(process.env.REACT_APP_ROUTER_BASE_URL, "/oa")) !== -1;
}
function isNatWestOneAccountSpecificUrl() {
  return pathName.indexOf("".concat(process.env.REACT_APP_ROUTER_BASE_URL, "/noa")) !== -1;
}